var Backbone, SupportAPIHelper, SupportHoldTimeModel, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportAPIHelper = require('../helpers/API');

SupportUtilsHelper = require('../helpers/utils');

Backbone = require('backbone');

SupportHoldTimeModel = (function(superClass) {
  extend(SupportHoldTimeModel, superClass);

  function SupportHoldTimeModel() {
    return SupportHoldTimeModel.__super__.constructor.apply(this, arguments);
  }

  SupportHoldTimeModel.prototype.initialize = function() {
    return this.holdTimeLocaleMap = {};
  };

  SupportHoldTimeModel.prototype.getWaitTimeInformation = function(locale, displayHoldTime) {
    var callBackHandler, url, waitTime;
    if (this.isWaitTimeSet(locale)) {
      waitTime = this.getWaitTimeForLocale(locale);
      return displayHoldTime(waitTime);
    } else {
      url = this.getHoldTimeUrlToFetchCallMeBackFlag(locale);
      callBackHandler = (function(_this) {
        return function(response) {
          if ((response != null ? response.estWaitTime : void 0) != null) {
            return _this.holdTimeSuccess(response, displayHoldTime);
          } else {
            return _this.holdTimeError(displayHoldTime);
          }
        };
      })(this);
      return SupportAPIHelper.get(url, null, callBackHandler, callBackHandler, false);
    }
  };

  SupportHoldTimeModel.prototype.getHoldTimeUrlToFetchCallMeBackFlag = function(locale) {
    var deal_type, ref, url;
    if (locale == null) {
      locale = window.I18n.locale;
    }
    deal_type = (ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0;
    if (deal_type != null) {
      url = window.SUPPORTBASEURL + "/hold_time/fetch?deal_type=" + deal_type + "&country_code=" + window.I18n.country;
    } else {
      url = url = window.SUPPORTBASEURL + "/hold_time/fetch?country_code=" + window.I18n.country;
    }
    if (locale != null) {
      url = url + ("&callback_locale=" + locale);
    }
    if (window.experiments.shouldEnableSBR && Groupon.Support.FeatureFlagModel.isSBREnabled() && (window.rating != null) && window.rating > 0) {
      url = url + ("&customer_rating=" + window.rating);
    }
    return SupportUtilsHelper.addMetaDataQueryParams(url);
  };

  SupportHoldTimeModel.prototype.holdTimeSuccess = function(response, displayHoldTime) {
    this.setWaitTimeForLocale(response.locale, response.estWaitTime);
    return displayHoldTime(response.estWaitTime);
  };

  SupportHoldTimeModel.prototype.holdTimeError = function(displayHoldTime) {
    var waitTime;
    waitTime = this.getDefaultHoldTime();
    return displayHoldTime(waitTime);
  };

  SupportHoldTimeModel.prototype.setWaitTimeForLocale = function(locale, waitTime) {
    return this.holdTimeLocaleMap[locale] = waitTime;
  };

  SupportHoldTimeModel.prototype.isWaitTimeSet = function(locale) {
    return !(this.holdTimeLocaleMap[locale] == null);
  };

  SupportHoldTimeModel.prototype.getWaitTimeForLocale = function(locale) {
    if (this.holdTimeLocaleMap[locale] != null) {
      return this.holdTimeLocaleMap[locale];
    } else {
      return this.getDefaultHoldTime();
    }
  };

  SupportHoldTimeModel.prototype.getDefaultHoldTime = function() {
    return I18n.translate('js.modules.support.one_hour');
  };

  return SupportHoldTimeModel;

})(Backbone.Model);

module.exports = SupportHoldTimeModel;

//# sourceMappingURL=data:application/json;base64,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
